import React from "react"
import autobind from "class-autobind"
import { Paper, TextField, Chip, Avatar, SelectField, MenuItem, FontIcon } from "material-ui"
import AvatarPlaceholder from "material-ui/svg-icons/action/perm-identity"
import { IClientDocument, IAddress, IClientContactDocument, EClientActiveStatus } from "../../../models"
import Address from "../../../components/address/Address"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import AddLogo from "../../../components/clients/upload_client_logo/AddLogo"
import ChooseHierarchyChip from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyChip"
import ChooseClientTypeChip from "../../../components/clients/choose_client_type/ChooseClientTypeChip"
import * as utils from "../../../helpers/utils"
import _ from "lodash"
import cloneDeep from "lodash/cloneDeep"
import moment from "moment-timezone"
import * as api from "../../../api"
import { EnumValues } from "enum-values"
import AppStateStore from "../../../stores/AppStateStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as permissionHelper from "../.././../helpers/permissionHelper"
interface IProps {
    readonly: boolean
    client: IClientDocument
    handleUpdateClient(client: IClientDocument): void
    uploadClientLogo(imageData: string): void
    removeClientLogo(): void
}
interface IState {
    expanded: boolean
    clientName: string
    errorName?: string
    clientType: string
    clientId: string
    mass90Id: string
    externalId3: string
    hierarchyId: string
    errorClientId?: string
    logo: string
    primaryContact: IClientContactDocument
    billingContact: IClientContactDocument
    activeStatus: EClientActiveStatus
    address: IAddress
    streetName: string
    houseOrBuliding: string
    city: string
    zip: string
    state: string
    referralSource: string
    referredBy: string
    showLogo: boolean
    showPrimaryBilling: boolean
    field1: string
    field2: string
    field3: string
    field4: string
}

export default class ClientDetailsSummary extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expanded: false,
            clientName: props.client.Name,
            errorName: "",
            clientType: props.client.Type,
            clientId: props.client.ExternalId ? props.client.ExternalId : "",
            mass90Id: props.client.ExternalId2 ? props.client.ExternalId2 : "",
            externalId3: props.client.ExternalId3 ? props.client.ExternalId3 : "",
            hierarchyId: props.client.HierarchyId ? props.client.HierarchyId : "",
            errorClientId: "",
            logo: props.client.LogoS3Url ? props.client.LogoS3Url : "",
            primaryContact: props.client.PrimaryContact ? props.client.PrimaryContact : null,
            billingContact: props.client.BillingContact ? props.client.BillingContact : null,
            activeStatus: props.client.ActiveStatus,
            address: props.client.ContactInfo ? props.client.ContactInfo.Address : null,
            streetName: props.client.ContactInfo && props.client.ContactInfo.Address ? props.client.ContactInfo.Address.StreetName : "",
            houseOrBuliding: props.client.ContactInfo && props.client.ContactInfo.Address ? props.client.ContactInfo.Address.HouseOrBuildingName : "",
            city: props.client.ContactInfo && props.client.ContactInfo.Address ? props.client.ContactInfo.Address.CityTown : "",
            zip: props.client.ContactInfo && props.client.ContactInfo.Address ? props.client.ContactInfo.Address.PostalArea : "",
            state: props.client.ContactInfo && props.client.ContactInfo.Address ? props.client.ContactInfo.Address.GoverningDistrictOrState : "",
            referralSource: props.client.ReferralSource,
            referredBy: props.client.ReferredBy,
            showLogo: true,
            showPrimaryBilling: true,
            field1: props.client.Field1 || "",
            field2: props.client.Field2 || "",
            field3: props.client.Field3 || "",
            field4: props.client.Field4 || "",
        }
        autobind(this)
    }

    componentWillReceiveProps(newProps) {
        if (newProps.client.LogoS3Url !== this.props.client.LogoS3Url) {
            this.setState({ logo: newProps.client.LogoS3Url, showLogo: false }, () => this.setState({ showLogo: true }))
        }
        if (
            !utils.isEquivalentObjects(this.props.client.PrimaryContact, newProps.client.PrimaryContact) ||
            !utils.isEquivalentObjects(this.props.client.BillingContact, newProps.client.BillingContact)
        ) {
            this.setState({ primaryContact: newProps.client.PrimaryContact, billingContact: newProps.client.BillingContact, showPrimaryBilling: false }, () =>
                this.setState({ showPrimaryBilling: true })
            )
        }
    }

    async updateClientData() {
        const client: IClientDocument = cloneDeep(this.props.client)
        const checkResult = await this.checkValidate()
        if (checkResult) {
            client.Name = this.state.clientName.trim()
            client.ExternalId = this.state.clientId.trim()
            client.ExternalId2 = this.state.mass90Id.trim();
            client.ExternalId3 = this.state.externalId3.trim()
            client.HierarchyId = this.state.hierarchyId
            client.ActiveStatus = this.state.activeStatus
            client.ContactInfo = { ...client.ContactInfo, Address: this.state.address }
            client.ReferralSource = this.state.referralSource
            client.ReferredBy = this.state.referredBy
            client.Type = this.state.clientType
            client.Field1 = this.state.field1 !== "" ? this.state.field1 : null
            client.Field2 = this.state.field2 !== "" ? this.state.field2 : null
            client.Field3 = this.state.field3 !== "" ? this.state.field3 : null
            client.Field4 = this.state.field4 !== "" ? this.state.field4 : null
            this.props.handleUpdateClient(client)
        }
    }

    onUploadClientLogo(imageData) {
        this.props.uploadClientLogo(imageData)
    }

    handleAddress(address: IAddress) {
        this.setState({ address: { ...this.state.address, ...address } }, () => this.updateClientData())
    }

    async checkValidate() {
        let isValid = true

        const clientName = this.state.clientName.trim()
        if (!clientName) {
            this.setState({ errorName: strings.NameRequired })
            isValid = false
        } else {
            if (this.props.client.Name === clientName) {
                this.setState({ errorName: "" })
            } else {
                const checkResult = await api.checkClientNameValid(clientName)
                if (!checkResult.data) {
                    this.setState({ errorName: strings.Name_is_duplicated })
                    isValid = false
                } else {
                    this.setState({ errorName: "" })
                }
            }
        }

        const clientId = this.state.clientId.trim()
        if (clientId) {
            if (this.props.client.ExternalId === clientId) {
                this.setState({ errorClientId: "" })
            } else {
                if (this.props.client.ExternalId === clientId) {
                    this.setState({ errorClientId: "" })
                } else {
                    const checkResult = await api.checkClientExternalIdValid(clientId)
                    if (!checkResult.data) {
                        this.setState({ errorClientId: strings.Client_Id_is_duplicated })
                        isValid = false
                    } else {
                        this.setState({ errorClientId: "" })
                    }
                }
            }
        } else {
            this.setState({ errorClientId: "" })
        }

        return isValid
    }

    saveClient = _.debounce(() => this.updateClientData(), 1000)

    render() {
        const defaultTimeZone =
            AccountStore.getCurrentAccountSettings() &&
            AccountStore.getCurrentAccountSettings().LocalizationSettings &&
            AccountStore.getCurrentAccountSettings().LocalizationSettings.DefaultIANATimezoneId
        let primaryContactName = this.state.primaryContact !== null ? `${this.state.primaryContact.FirstName} ${this.state.primaryContact.LastName}` : strings.No_Primary_Contact
        if (this.state.primaryContact && this.state.primaryContact.PreferredName !== "" && this.state.primaryContact.PreferredName !== null) {
            if (this.state.primaryContact.LastName !== "" && this.state.primaryContact.LastName !== null)
                primaryContactName = `${this.state.primaryContact.PreferredName} ${this.state.primaryContact.LastName}`
            else primaryContactName = this.state.primaryContact.PreferredName
        }
        const editCutomFieldsAllowed = permissionHelper.hasPermission(AuthenticationStore.Permissions.Clients.EditCustomClientFields)
        const customFieldLabels = AccountStore.getCurrentAccountSettings() && AccountStore.getCurrentAccountSettings().CustomFieldSettings.ClientCustomLabels
        return (
            <Paper zDepth={1} style={{ textAlign: "left", margin: 20, position: "relative", overFlow: "hidden", padding: 20 }}>
                <div style={{ fontSize: 25, fontWeight: "bold" }}>
                    {strings.Client_Details}
                    <FontIcon
                        className="fa fa-info-circle"
                        style={{ fontSize: 20, color: "#777777", cursor: "pointer", position: "absolute", top: 5, }}
                        onTouchTap={() => AppStateStore.setNoteDrawerContent({
                            drawerTitle: `${this.props.client ? this.props.client.Name : ""}`,
                            objectData: {
                                ObjectId: this.props.client && this.props.client.Id
                            },
                            objectName: this.props.client.Name,
                            dataType: "client",
                        })}
                    />
                </div>
                {this.state.expanded && (
                    <div>
                        <div style={{ display: "flex" }}>
                            <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
                                <TextField
                                    floatingLabelText={strings.Client_Name}
                                    style={{ width: 400 }}
                                    value={this.state.clientName || ""}
                                    title={this.state.clientName}
                                    errorText={this.state.errorName}
                                    errorStyle={{ position: "absolute", bottom: -10 }}
                                    onChange={(event) => this.setState({ clientName: event.target.value }, () => this.checkValidate())}
                                    onBlur={() => this.updateClientData()}
                                    disabled={this.props.readonly}
                                />
                                <div style={{ marginTop: 10 }}>
                                    <div style={{ minWidth: 400, flex: 1, paddingRight: 10 }}>
                                        {this.state.showLogo && (
                                            <AddLogo
                                                readonly={this.props.readonly}
                                                logoUrl={this.state.logo}
                                                onUploadClientLogo={this.onUploadClientLogo}
                                                onRemoveClientLogo={() => this.props.removeClientLogo()}
                                            />
                                        )}
                                        <br></br>
                                        <div>
                                            <ChooseHierarchyChip
                                                readonly={this.props.readonly}
                                                chipLabel={strings.HierarchyLevel}
                                                hierarchyItemId={this.state.hierarchyId}
                                                handleSelectHierarchy={(hierarchyId) => this.setState({ hierarchyId }, () => this.updateClientData())}
                                            />
                                        </div>
                                        {AccountStore.getHREnabled() &&
                                            <div>
                                                <ChooseClientTypeChip
                                                    disabled={this.props.readonly}
                                                    selectedClientType={this.state.clientType}
                                                    handleSave={(clientType: string) => {
                                                        if (clientType) this.setState({ clientType }, () => this.updateClientData())
                                                        else this.setState({ clientType: null }, () => this.updateClientData())
                                                    }}
                                                />
                                            </div>
                                        }
                                        {this.state.showPrimaryBilling && [
                                            <div key="primary">
                                                <label>{strings.Primary_Contact}</label>
                                                <Chip style={{ marginTop: 3 }}>
                                                    <Avatar
                                                        icon={this.state.primaryContact && this.state.primaryContact.ProfileImageS3Url ?
                                                            null :
                                                            <AvatarPlaceholder />
                                                        }
                                                        src={this.state.primaryContact && this.state.primaryContact.ProfileImageS3Url ?
                                                            this.state.primaryContact.ProfileImageS3Url :
                                                            ""
                                                        }
                                                    />
                                                    {primaryContactName}
                                                </Chip>
                                            </div>,
                                            <div style={{ marginTop: 7 }} key="billing">
                                                <label>{strings.Billing_Contact}</label>
                                                <Chip style={{ marginTop: 3 }}>
                                                    <Avatar
                                                        icon={this.state.billingContact && this.state.billingContact.ProfileImageS3Url ?
                                                            null :
                                                            <AvatarPlaceholder />
                                                        }
                                                        src={this.state.billingContact && this.state.billingContact.ProfileImageS3Url ?
                                                            this.state.billingContact.ProfileImageS3Url :
                                                            ""
                                                        }
                                                    />
                                                    {this.state.billingContact !== null ? `${this.state.billingContact.FirstName} ${this.state.billingContact.LastName}` : strings.No_Billing_Contact}
                                                </Chip>
                                            </div>
                                        ]}
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: 2 }}>
                                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                    <TextField
                                        floatingLabelText={strings.Client_Id}
                                        value={this.state.clientId || ""}
                                        style={{ width: 180 }}
                                        errorText={this.state.errorClientId}
                                        errorStyle={{ position: "absolute", bottom: -10 }}
                                        onChange={(event) => this.setState({ clientId: event.target.value }, () => this.checkValidate())}
                                        onBlur={() => this.updateClientData()}
                                        disabled={this.props.readonly}
                                    />
                                </div>
                                <div style={{ paddingLeft: 10, paddingRight: 10, marginTop: -3.5 }}>
                                    <SelectField
                                        disabled={this.props.readonly}
                                        floatingLabelText={strings.Active_Status}
                                        style={{ width: 180 }}
                                        value={this.state.activeStatus}
                                        onChange={(event, index, value) => this.setState({ activeStatus: value }, () => this.updateClientData())}
                                    >
                                        {EnumValues.getNamesAndValues(EClientActiveStatus).map((item, i) => (
                                            <MenuItem key={i} value={item.value} primaryText={strings[item.name]} />
                                        ))}
                                    </SelectField>
                                </div>
                                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                    <TextField
                                        floatingLabelText={(customFieldLabels.Field1Label === null || customFieldLabels.Field1Label === undefined || customFieldLabels.Field1Label === "") ? `${strings.Custom_Field} 1` : customFieldLabels.Field1Label}
                                        style={{ width: 180 }}
                                        value={this.state.field1}
                                        onChange={e => this.setState({ field1: e.target.value }, () => this.saveClient())}
                                        underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                                        disabled={editCutomFieldsAllowed ? this.props.readonly : true}
                                    />
                                </div>
                                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                    <TextField
                                        floatingLabelText={(customFieldLabels.Field2Label === null || customFieldLabels.Field2Label === undefined || customFieldLabels.Field2Label === "") ? `${strings.Custom_Field} 2` : customFieldLabels.Field2Label}
                                        style={{ width: 180 }}
                                        value={this.state.field2}
                                        onChange={e => this.setState({ field2: e.target.value }, () => this.saveClient())}
                                        underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                                        disabled={editCutomFieldsAllowed ? this.props.readonly : true}
                                    />
                                </div>
                                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                    <TextField
                                        floatingLabelText={(customFieldLabels.Field3Label === null || customFieldLabels.Field3Label === undefined || customFieldLabels.Field3Label === "") ? `${strings.Custom_Field} 3` : customFieldLabels.Field3Label}
                                        style={{ width: 180 }}
                                        value={this.state.field3}
                                        onChange={e => this.setState({ field3: e.target.value }, () => this.saveClient())}
                                        underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                                        disabled={editCutomFieldsAllowed ? this.props.readonly : true}
                                    />
                                </div>
                                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                    <TextField
                                        floatingLabelText={(customFieldLabels.Field4Label === null || customFieldLabels.Field4Label === undefined || customFieldLabels.Field4Label === "") ? `${strings.Custom_Field} 4` : customFieldLabels.Field4Label}
                                        style={{ width: 180 }}
                                        value={this.state.field4}
                                        onChange={e => this.setState({ field4: e.target.value }, () => this.saveClient())}
                                        underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                                        disabled={editCutomFieldsAllowed ? this.props.readonly : true}
                                    />
                                </div>
                            </div>
                            <Address readonly={this.props.readonly} address={this.state.address} handleAddress={this.handleAddress} showLatLng={true} />
                        </div>
                        <div style={{ display: "flex", alignItems: "baseline" }}>
                            <div style={{ paddingLeft: 10, paddingRight: 10, minWidth: 400, display: "flex" }}>
                                <div style={{ paddingRight: 10 }}>
                                    <TextField
                                        floatingLabelText={strings.Referral_Source}
                                        style={{ width: 175 }}
                                        value={this.state.referralSource || ""}
                                        onChange={(event) => this.setState({ referralSource: event.target.value }, () => this.checkValidate())}
                                        onBlur={() => this.updateClientData()}
                                        disabled={this.props.readonly}
                                    />
                                </div>
                                <div style={{ paddingLeft: 10 }}>
                                    <TextField
                                        floatingLabelText={strings.Referred_By}
                                        style={{ width: 175 }}
                                        value={this.state.referredBy || ""}
                                        onChange={(event) => this.setState({ referredBy: event.target.value }, () => this.checkValidate())}
                                        onBlur={() => this.updateClientData()}
                                        disabled={this.props.readonly}
                                    />
                                </div>
                            </div>
                            <div style={styles.flexItem}>
                                <hr style={{ marginRight: -20 }} />
                                <p style={{ margin: 0, padding: 0 }}>{`${strings.Created}: ${moment.tz(this.props.client.ObjectAudit.CreatedDate, defaultTimeZone).format("MM/DD/YYYY hh:mm a")}`}</p>
                                <p style={{ margin: 0, padding: 0 }}>{`${strings.Created_By}: ${this.props.client.ObjectAudit.CreatedByName ? this.props.client.ObjectAudit.CreatedByName : ""}`}</p>
                            </div>
                            <div style={styles.flexItem}>
                                <hr />
                                <p style={{ margin: 0, padding: 0 }}>{`${strings.Modified}: ${moment.tz(this.props.client.ObjectAudit.LastModified, defaultTimeZone).format("MM/DD/YYYY hh:mm a")}`}</p>
                                <p style={{ margin: 0, padding: 0 }}>{`${strings.Modified_By}: ${this.props.client.ObjectAudit.LastModifiedByName ? this.props.client.ObjectAudit.LastModifiedByName : ""
                                    }`}</p>
                            </div>
                        </div>
                    </div>
                )}
                <div style={{ position: "absolute", right: 17, top: 10, fontSize: 18 }}>
                    <i className={"fa " + (this.state.expanded ? "fa-chevron-up" : "fa-chevron-down") + " itemActionButton"} onClick={() => this.setState({ expanded: !this.state.expanded })} />
                </div>
            </Paper>
        )
    }
}

const styles = {
    flexItem: { paddingLeft: 10, paddingRight: 10, flex: 1 }
}
